import { _ } from "../../../core/polyglot/polyglot.js";
import { Node } from "prosemirror-model";
import InsertInputValueAction from "../actions/InsertInputValueAction.js";
import SuggestionAction from "../actions/SuggestionAction/SuggestionAction.js";

/**
 * Todo: Add JSDoc comment
 */
export default function getKeyFigureExtraSpecs({
	getPeriodReportValuesKeyFigurePreset,
}) {
	const keyFiguresPromise = getPeriodReportValuesKeyFigurePreset().then(
		(result) => result.getKeyFigures(),
	);

	return [
		makeKeyFigureDropdownBuilder({ keyFiguresPromise }),
		makeKeyFigureSuggestionsBuilder({ suggestions: keyFiguresPromise }),
	];
}

function makeKeyFigureDropdownBuilder({ keyFiguresPromise }) {
	return () =>
		new InsertInputValueAction({
			type: "keyfigure",
			label: _("KPIs"),
			order: 110,
			dataTestName: "insert-kpi",
			items: keyFiguresPromise,
		});
}

function makeKeyFigureSuggestionsBuilder({ suggestions }) {
	return () =>
		new SuggestionAction({
			type: "keyfigure",
			suggestionToNode,
			suggestionToLabel: (item) => item.getName(),
			suggestions,
		});
}

function suggestionToNode({ type, item, schema }) {
	return Node.fromJSON(schema, {
		type: `inputValue_${type}`,
		attrs: {
			id: item.getId(),
		},
	});
}
